import SegmentFilter from './SegmentFilter'
import SegmentFilterSeparator from './SegmentFilterSeparator'
import { SegmentRule } from './types'

interface SegmentGroupRulesProps {
  rules: SegmentRule[]
  operator: 'AND' | 'OR' | 'EXCEPT'
  isExceptGroup: boolean
}

const SegmentGroupRules = ({
  rules,
  operator,
  isExceptGroup,
}: SegmentGroupRulesProps) => {
  const ruleItems = rules.map((rule, ruleIndex) => {
    const showSeparator = ruleIndex > 0
    const ruleKey = rule.id || `rule-${ruleIndex}`

    return (
      <div key={ruleKey}>
        {showSeparator && <SegmentFilterSeparator operator={operator} />}
        <SegmentFilter rule={rule} isNegated={isExceptGroup} />
      </div>
    )
  })

  return <>{ruleItems}</>
}

export default SegmentGroupRules
